/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_IntroInputs */

const en_us2_body_assessment_consent_intro = /** @type {(inputs: Body_Assessment_Consent_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To work out the estimate, the app needs two full-body photos and a few numbers from you. Here is exactly where they go.`)
};

const pt_br2_body_assessment_consent_intro = /** @type {(inputs: Body_Assessment_Consent_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para calcular a estimativa, o app precisa de duas fotos do corpo inteiro e de alguns dados seus. Aqui está exatamente para onde eles vão.`)
};

const es_419_body_assessment_consent_intro = /** @type {(inputs: Body_Assessment_Consent_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para calcular la estimación, la app necesita dos fotos de cuerpo entero y algunos datos tuyos. Aquí está exactamente adónde van.`)
};

const pt_pt2_body_assessment_consent_intro = /** @type {(inputs: Body_Assessment_Consent_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para calcular a estimativa, a app precisa de duas fotos de corpo inteiro e de alguns dados teus. Eis exatamente para onde vão.`)
};

const fr_fr2_body_assessment_consent_intro = /** @type {(inputs: Body_Assessment_Consent_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour calculer l'estimation, l'app a besoin de deux photos en pied et de quelques données. Voici exactement où elles vont.`)
};

const de_de2_body_assessment_consent_intro = /** @type {(inputs: Body_Assessment_Consent_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Schätzung braucht die App zwei Ganzkörperfotos und ein paar Angaben von dir. Hier steht genau, wohin sie gehen.`)
};

const it_it2_body_assessment_consent_intro = /** @type {(inputs: Body_Assessment_Consent_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per calcolare la stima, l'app ha bisogno di due foto a figura intera e di alcuni tuoi dati. Ecco esattamente dove vanno.`)
};

/**
* | output |
* | --- |
* | "To work out the estimate, the app needs two full-body photos and a few numbers from you. Here is exactly where they go." |
*
* @param {Body_Assessment_Consent_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_intro = /** @type {((inputs?: Body_Assessment_Consent_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_intro(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_intro(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_intro(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_intro(inputs)
	return en_us2_body_assessment_consent_intro(inputs)
});
export { body_assessment_consent_intro as "body-assessment.consent_intro" }